import { cn } from '@/lib/utils';
import { LoaderCircle, RefreshCw } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger
} from '@/components/ui/tooltip';

import { BIG_ICON_BUTTON, BIG_TEXT_MUTED } from './bigBarStyle';
import { TOOLBAR_TOOLTIP } from './toolbarTooltip';

interface DashboardStatusProps {
    summary: string;
    failed: boolean;
    loading: boolean;
    spinning: boolean;
    onRefresh: () => void;
    variant?: 'app' | 'big';
}

export function DashboardStatus({
    summary,
    failed,
    loading,
    spinning,
    onRefresh,
    variant = 'app'
}: DashboardStatusProps) {
    const big = variant === 'big';
    const refreshIcon =
        loading || spinning ? (
            <LoaderCircle data-spinner className="w-3.5 h-3.5 animate-slow-spin" />
        ) : (
            <RefreshCw className="w-4 h-4" />
        );
    return (
        <>
            <span
                className={cn(
                    big ? 'text-xs' : 'text-caption',
                    failed && !loading
                        ? 'text-destructive'
                        : big
                        ? BIG_TEXT_MUTED
                        : 'text-muted-foreground'
                )}
            >
                {summary}
            </span>
            <Tooltip>
                <TooltipTrigger asChild>
                    {big ? (
                        <button
                            type="button"
                            onClick={onRefresh}
                            disabled={loading}
                            aria-label="Refresh data"
                            className={BIG_ICON_BUTTON}
                        >
                            {refreshIcon}
                        </button>
                    ) : (
                        <Button
                            variant="bare"
                            size="icon-sm"
                            onClick={onRefresh}
                            disabled={loading}
                            aria-label="Refresh data"
                        >
                            {refreshIcon}
                        </Button>
                    )}
                </TooltipTrigger>
                <TooltipContent {...TOOLBAR_TOOLTIP}>
                    Refresh data
                </TooltipContent>
            </Tooltip>
        </>
    );
}
